var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74202 15.9902L5.49902 11.7462L6.91302 10.3322L9.74202 13.1602L15.398 7.50317L16.813 8.91817L9.74202 15.9902Z",
    fill: "#374151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.498047 11.6763C0.498047 5.60127 5.42305 0.67627 11.498 0.67627C17.573 0.67627 22.498 5.60127 22.498 11.6763C22.498 17.7513 17.573 22.6763 11.498 22.6763C5.42305 22.6763 0.498047 17.7513 0.498047 11.6763ZM11.498 20.6763C10.3161 20.6763 9.14583 20.4435 8.0539 19.9912C6.96197 19.5389 5.96981 18.876 5.13409 18.0402C4.29836 17.2045 3.63542 16.2124 3.18313 15.1204C2.73084 14.0285 2.49805 12.8582 2.49805 11.6763C2.49805 10.4944 2.73084 9.32405 3.18313 8.23212C3.63542 7.14019 4.29836 6.14804 5.13409 5.31231C5.96981 4.47658 6.96197 3.81365 8.0539 3.36135C9.14583 2.90906 10.3161 2.67627 11.498 2.67627C13.885 2.67627 16.1742 3.62448 17.862 5.31231C19.5498 7.00014 20.498 9.28932 20.498 11.6763C20.498 14.0632 19.5498 16.3524 17.862 18.0402C16.1742 19.7281 13.885 20.6763 11.498 20.6763Z",
    fill: "#374151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.e3f009c0ed826683adb2829bdfa33465.svg";
export { ForwardRef as ReactComponent };